import { render } from "./form.vue?vue&type=template&id=e38abac6&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=e38abac6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e38abac6"

export default script